import apiServices from '../../ApiServices/request-handler';
import { requestHandler } from '../../utils/functions';
import { setAuthLoading } from '../slices/authSlice';
import {
  setApplicantLoading,
  setApplicantTypes,
  setIndPostLoading,
  setIndBankInformationData,
  setIndBankInformationDropdownData,
  setIndClientClassificationData,
  setIndClientClassificationDropdown,
  setIndContactInformationData,
  setIndContactInformationDropdownData,
  setIndDocumentVaultData,
  setIndDocumentVaultDropdownData,
  setIndEmployerInformationData,
  setIndEmployerInformationDropdownDrop,
  setIndGeneralInformationData,
  setIndGeneralInformationDropdownDrop,
  setIndInvestmentPorfolioData,
  setIndInvestmentPortfolioDropdownData,
  setIndividualLoading,
  setIndPersonalInformationData,
  setIndPersonalInformationDropdownData,
  setIndTaxDeclarationData,
  setIndTaxDeclarationDropdownData,
  setIndUploadDocumentInformation,
  setIndKsaBankList,
  setIndNonksaBankList,
  setIndApplicationStatus,
  setDeleteBankLoading,
  setBankLoading,
} from '../slices/individualSlice';
import { showToast } from '../../utils/utils';
import { setApplicantType, setClientApplicationId, setClientId, setIsKyc, setNafathCode } from '../slices/constantSlice';
import { setKycLoading } from '../slices/corporateSlice';

export const updateNafath = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.updateNafath,
        param_data: data,
        isErrorMessage: false,
        onDone: (data) => {
          onDone();
        },
      }),
    );
  };
};

export const indCreateAccount = (data, navigate) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.indCreateAccount,
        param_data: data,
        onDone: (res) => {
          dispatch(setClientId(res?.result));
          dispatch(setIsKyc(false));
          navigate('/otp', {
            state: {
              clientId: res?.result,
              data: data,
            },
          });
        },
      }),
    );
  };
};

export const getAllTypes = () => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        apiService: apiServices.getApplicantTypes,
        onDone: (data) => dispatch(setApplicantTypes(data?.result)),
      }),
    );
  };
};

export const getAllArabicTypes = () => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        apiService: apiServices.getArabicApplicantTypes,
        onDone: (data) => dispatch(setApplicantTypes(data?.result)),
      }),
    );
  };
};

export const createNationalApplication = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.createApplicationForNationalsAndResidents,
        param_data: data,
        onDone: async (res) => {
          const type = data?.applicantTypeId === 12 ? 'KSA Resident' : 'KSA National';
          dispatch(setApplicantType(type));
          dispatch(setClientApplicationId(res?.result));
          onDone && onDone();
        },
      }),
    );
  };
};

export const sendNafathVerificationRequest = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.postNafathVerificationRequest,
        param_data: data,
        onDone: (data) => {
          dispatch(setNafathCode(data?.data));
          onDone && onDone();
        },
      }),
    );
  };
};

export const AccountOpeningGccOthersViaApplicantType = (data, navigate) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.createApplicationForGccAndOthers,
        param_data: data,
        onDone: async (res) => {
          if (res?.status) {
            const type = data?.applicantTypeId === 13 ? 'GCC National' : 'Other National';
            dispatch(setApplicantType(type));
            dispatch(setClientApplicationId(res?.result));
            navigate('/individual-form');
          } else {
            showToast({
              icon: 'error',
              title: res?.result ?? 'Something went wrong',
            });
          }
        },
      }),
    );
  };
};

// Personal Information
export const getIndPersonalInformationDropdownData = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        param_data: data,
        apiService: apiServices.getIndPersonalInformationDropdownData,
        onDone: (data) => {
          dispatch(setIndPersonalInformationData(data?.result?.inputs));
          dispatch(setIndPersonalInformationDropdownData(data?.result?.selections));
        },
      }),
    );
};

// Contact Information
export const getIndContactInformationData = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        param_data: data,
        apiService: apiServices.getIndContactInformationData,
        onDone: (data) => {
          dispatch(setIndContactInformationData(data?.result?.inputs));
          dispatch(setIndContactInformationDropdownData(data?.result?.selections));
        },
      }),
    );
};

// Employer Information
export const getIndEmployerInformationData = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        param_data: data,
        apiService: apiServices.getIndEmployerInformationData,
        onDone: (data) => {
          dispatch(setIndEmployerInformationData(data?.result?.inputs));
          dispatch(setIndEmployerInformationDropdownDrop(data?.result?.selections));
        },
      }),
    );
};

// General Information
export const getIndGeneralInformationData = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        param_data: data,
        apiService: apiServices.getIndGeneralInformationData,
        onDone: (data) => {
          dispatch(setIndGeneralInformationData(data?.result?.inputs));
          dispatch(setIndGeneralInformationDropdownDrop(data?.result?.selections));
        },
      }),
    );
};

// Bank & Custodian Information
export const getIndBankInformationData = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        param_data: data,
        apiService: apiServices.getIndBankInformationData,
        onDone: (data) => {
          dispatch(setIndBankInformationData(data));
          dispatch(setIndBankInformationDropdownData(data?.result?.selections));
        },
      }),
    );
};

export const getIndKycKsaBank = (params, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        apiService: apiServices.getIndKycKsaBank,
        setData: setIndKsaBankList,
        param_data: params,
        onDone: (res) => onDone?.(res),
      }),
    );
  };
};

export const getIndKycNonKsaBank = (params, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        apiService: apiServices.getIndKycNonKsaBank,
        param_data: params,
        setData: setIndNonksaBankList,
        onDone: (res) => {
          onDone?.(res?.result);
        },
      }),
    );
};

export const getIndKsaBank = (params, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        apiService: apiServices.getIndKsaBank,
        setData: setIndKsaBankList,
        param_data: params,
        onDone: (res) => onDone?.(res),
      }),
    );
};

export const getIndNonKsaBank = (params, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        apiService: apiServices.getIndNonKsaBank,
        param_data: params,
        setData: setIndNonksaBankList,
        onDone: (res) => onDone?.(res),
      }),
    );
};

export const addIndKycKsaBank = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setBankLoading,
        apiService: apiServices.addIndKycKsaBank,
        param_data: data,
        onDone: async (data) => {
          onDone && onDone();
        },
      }),
    );
  };
};

export const addIndKycNonKsaBank = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setBankLoading,
        apiService: apiServices.addIndKycNonKsaBank,
        param_data: data,
        onDone: async (data) => {
          onDone && onDone();
        },
      }),
    );
  };
};

export const addIndKsaBank = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setBankLoading,
        apiService: apiServices.addIndKsaBank,
        param_data: data,
        onDone: async (data) => {
          onDone && onDone();
        },
      }),
    );
  };
};

export const addIndNonKsaBank = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setBankLoading,
        apiService: apiServices.addIndNonKsaBank,
        param_data: data,
        onDone,
      }),
    );
  };
};

export const deleteIndKycNonKsaBank = (params, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setDeleteBankLoading,
        apiService: apiServices.deleteIndKycNonKsaBank,
        param_data: params,
        onDone: async (data) => {
          onDone && onDone();
        },
      }),
    );
  };
};

export const deleteIndKycKsaBank = (params, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setDeleteBankLoading,
        apiService: apiServices.deleteIndKycKsaBank,
        param_data: params,
        onDone: async (data) => {
          onDone && onDone();
        },
      }),
    );
  };
};

export const deleteIndNonKsaBank = (params, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setDeleteBankLoading,
        apiService: apiServices.deleteIndNonKsaBank,
        param_data: params,
        onDone,
      }),
    );
  };
};

export const deleteIndKsaBank = (params, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setDeleteBankLoading,
        apiService: apiServices.deleteIndKsaBank,
        param_data: params,
        onDone: async (data) => {
          onDone && onDone();
        },
      }),
    );
  };
};

export const editIndKycNonKsaBank = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setBankLoading,
        apiService: apiServices.editIndKycNonKsaBank,
        param_data: data,
        onDone: async (data) => {
          onDone && onDone();
        },
      }),
    );
  };
};

export const editIndKycKsaBank = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setBankLoading,
        apiService: apiServices.editIndKycKsaBank,
        param_data: data,
        onDone: async (data) => {
          onDone && onDone();
        },
      }),
    );
  };
};

export const editIndNonKsaBank = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setBankLoading,
        apiService: apiServices.editIndNonKsaBank,
        param_data: data,
        onDone,
      }),
    );
  };
};

export const editIndKsaBank = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setBankLoading,
        apiService: apiServices.editIndKsaBank,
        param_data: data,
        onDone: async (data) => {
          onDone && onDone();
        },
      }),
    );
  };
};

// Investment Portfolio
export const getIndInvestmentPortfolioData = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        param_data: data,
        apiService: apiServices.getIndInvestmentPortfolioData,
        onDone: (data) => {
          dispatch(setIndInvestmentPorfolioData(data?.result?.inputs));
          dispatch(setIndInvestmentPortfolioDropdownData(data?.result?.selections));
        },
      }),
    );
};

// Client Classification
export const getIndClientClassificationData = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        param_data: data,
        apiService: apiServices.getIndClientClassificationData,
        onDone: (data) => {
          dispatch(setIndClientClassificationData(data?.result?.inputs));
          dispatch(setIndClientClassificationDropdown(data?.result?.selections));
        },
      }),
    );
};

// Tax Declaration
export const getIndTaxDeclarationData = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        param_data: data,
        apiService: apiServices.getIndTaxDeclarationData,
        onDone: (data) => {
          dispatch(setIndTaxDeclarationData(data?.result?.inputs));
          dispatch(setIndTaxDeclarationDropdownData(data?.result?.selections));
        },
      }),
    );
};

// Document Vault
export const getIndDocumentVaultData = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        param_data: data,
        apiService: apiServices.getIndDocumentVaultData,
        onDone: (data) => {
          dispatch(setIndDocumentVaultData(data?.result?.inputs));
          dispatch(setIndDocumentVaultDropdownData(data?.result?.selections));
        },
      }),
    );
};

// Post Form Submit Actions ---
// Ind Personal Information
export const postIndPersonalInformation = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.postIndPersonalInformation,
        param_data: data,
        onDone,
      }),
    );
  };
};

// Ind Contact Information
export const postIndContactInformation = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.postIndContactInformation,
        param_data: data,
        onDone,
      }),
    );
  };
};

// Ind Employer Information
export const postIndEmployerInformation = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.postIndEmployerInformation,
        param_data: data,
        onDone,
      }),
    );
  };
};

// Ind General Information
export const postIndGeneralInformation = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.postIndGeneralInformation,
        param_data: data,
        onDone,
      }),
    );
  };
};

// Ind Bank Information
export const postIndBankInformation = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.postIndBankInformation,
        param_data: data,
        onDone,
      }),
    );
  };
};

export const saveKycBankCustodianInformation = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.saveKycBankCustodianInformation,
        param_data: data,
        onDone: (data) => {
          onDone();
        },
      }),
    );
  };
};

// Ind Investment Portfolio
export const postIndInvestmentPortfolio = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.postIndInvestmentPortfolio,
        param_data: data,
        onDone,
      }),
    );
  };
};

// Ind Client Classification
export const postIndClientClassification = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.postIndClientClassification,
        param_data: data,
        onDone,
      }),
    );
  };
};

// Ind Document Client Classification
export const postIndDocumentClientClassification = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.postIndDocumentClientClassification,
        param_data: data,
        onDone: (data) => {
          onDone(data);
        },
      }),
    );
  };
};

// Ind Tax Declaration
export const postIndTaxDeclaration = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.postIndTaxDeclaration,
        param_data: data,
        onDone: (data) => {
          onDone(data);
        },
      }),
    );
  };
};

// Add Document
export const getIndUploadedDocumentsData = (data) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.getIndUploadedDocumentsData,
        param_data: data,
        setData: setIndUploadDocumentInformation,
      }),
    );
  };
};

// Ind Document Vault
export const postIndDocumentVault = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.postIndDocumentVault,
        param_data: data,
        onDone: (data) => {
          onDone(data);
        },
      }),
    );
  };
};

export const submitIndApplication = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.submitIndApplication,
        param_data: data,
        isSuccessMessage: true,
        onDone,
      }),
    );
  };
};

// Kyc Individual

export const saveIndKycPersonalInformation = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.saveIndKycPersonalInformation,
        param_data: data,
        onDone,
      }),
    );
  };
};

export const saveIndKycContactInformation = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.saveIndKycContactInformation,
        param_data: data,
        onDone,
      }),
    );
  };
};

export const saveIndKycEmployerInformation = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.saveIndKycEmployerInformation,
        param_data: data,
        onDone,
      }),
    );
  };
};

export const saveIndKycGeneralInformation = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.saveIndKycGeneralInformation,
        param_data: data,
        onDone,
      }),
    );
  };
};

export const saveIndKycBankCustodianInformation = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.saveIndKycBankCustodianInformation,
        param_data: data,
        onDone: (data) => {
          onDone();
        },
      }),
    );
  };
};

export const saveIndKycInvestmentPortfolio = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.saveIndKycInvestmentPortfolio,
        param_data: data,
        onDone,
      }),
    );
  };
};

export const saveIndKycClientClassification = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.saveIndKycClientClassification,
        param_data: data,
        onDone,
      }),
    );
  };
};

export const saveIndKycTaxDeclaration = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setIndPostLoading,
        apiService: apiServices.saveIndKycTaxDeclaration,
        param_data: data,
        onDone: (data) => {
          onDone();
        },
      }),
    );
  };
};

export const postIndKycDocumentVault = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        apiService: apiServices.postIndKycDocumentVault,
        param_data: data,
        onDone,
      }),
    );
  };
};

export const getIndApplicationStatus = (data) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        apiService: apiServices.getIndApplicationStatus,
        param_data: data,
        onDone: (res) => {
          dispatch(setIndApplicationStatus(res?.data));
        },
      }),
    );
};

export const submitIndKycApplication = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setApplicantLoading,
        apiService: apiServices.submitIndKycApplication,
        param_data: data,
        onDone,
      }),
    );
  };
};

export const createKycApplication = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setKycLoading,
        apiService: apiServices.createKycApplication,
        param_data: data,
        onDone: (data) => {
          onDone(data);
        },
      }),
    );
  };
};

export const initiateIndKyc = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setKycLoading,
        apiService: apiServices.initiateIndKyc,
        param_data: data,
        onDone: (data) => {
          onDone(data?.result);
        },
      }),
    );
  };
};
